/**
 * Copyright © OXID eSales AG. All rights reserved.
 * See LICENSE file for license details.
 */

document.addEventListener("DOMContentLoaded", function() {
    const zoomModal = document.getElementById('zoomModal');
    if (!zoomModal) {
        return;
    }

    const zoomContainers = zoomModal.querySelectorAll('.carousel-item');
    zoomContainers.forEach(container => {
        const img = container.querySelector('img');

        img.addEventListener('click', function(e) {
            if (img.classList.contains('zoom')) {
                img.classList.remove('zoom')
            } else {
                img.classList.add('zoom')
            }
        });

        img.addEventListener('mousemove', function(e) {
            const rect = img.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            // Calculate percentage positions for transform origin
            const xPercent = (x / rect.width) * 100;
            const yPercent = (y / rect.height) * 100;

            // Set transform origin
            img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
        });
    });

    zoomModal.addEventListener('hidden.bs.modal', function (event) {
        const modalZoomImages = zoomModal.querySelectorAll('.carousel-item img.zoom');
        modalZoomImages.forEach(img => {
            img.classList.remove('zoom');
        });
    });

    const carousel = document.getElementById('carouselZoomPicturesIndicators');
    if (carousel) {
        carousel.addEventListener('slid.bs.carousel', function (event) {
            const thumbs = zoomModal.querySelectorAll('.carouselThumbnail');
            thumbs.forEach(t => {
                t.classList.remove('active');
                t.removeAttribute('aria-current');
            });
            if (thumbs[event.to]) {
                thumbs[event.to].classList.add('active');
                thumbs[event.to].setAttribute('aria-current', 'true');
            }
        });

        const thumbs = zoomModal.querySelectorAll('.carouselThumbnail');
        thumbs.forEach(thumb => {
            thumb.addEventListener('click', function () {
                thumbs.forEach(t => {
                    t.classList.remove('active');
                    t.removeAttribute('aria-current');
                });
                this.classList.add('active');
                this.setAttribute('aria-current', 'true');
            });
        });
    }
});
